import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const Features = () => (
  <Section id="features">
    <StyledContainer>
      <Subtitle>Features</Subtitle>
      <SectionTitle>Payments. Simple.</SectionTitle>
      <FeaturesGrid>
        <FeatureItem>
          <FeatureTitle>Merchant</FeatureTitle>
          <FeatureText>
            Separate Merchant app for easy payment monitoring. Issue checks, view payments and reports, all
            with just a few taps.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Secure</FeatureTitle>
          <FeatureText>We utilize Stripe, a well known and trusted credit card processor. Chargeback protection
            available, if you want it.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Customer</FeatureTitle>
          <FeatureText>
            Customer app for opening tabs, remembering payment info and just being cool. Use Google Pay, Apple Pay,
            or enter your own card info.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Easy</FeatureTitle>
          <FeatureText>
            Have a merchant bank account and tax ID? From sign up to payment, it's as easy as 1 - 2 - 3.
            Customers use any method saved in their phone.
          </FeatureText>
        </FeatureItem>
      </FeaturesGrid>
    </StyledContainer>
  </Section>
)

export default Features

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 0px;
  margin-bottom: 12px;
  text-align: center;
`

const FeaturesGrid = styled.div`
  max-width: 670px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0px auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
`

const FeatureItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const FeatureTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 10px;
`

const FeatureText = styled.p`
  text-align: center;
`
